<div [ngClass]="{'container': !isFullWidth, 'container-fluid': isFullWidth}" [style.display]="searchVisible ? 'block' : 'none'">
  <div class="row p-xl-2">
    @if (
      (!imageBankTab || imageBankTab === 'articles' || selectedTab === 'search') && showSideBar
      ) {
      <div
        id="sidebar-wrapper"
        class="px-0 col-md-3 col-lg-3 col-xl-2 col-sm-4 pe-md-0 ps-md-2"
        [ngClass]="selectedTab !== 'favorites' ? 'd-sm-block' : 'd-none'"
        [@flyIn]
        >
        <app-side-bar
          #sideBar
          style="width: 100%"
          [priceRangeData]="priceRangeData"
          [stockweekData]="stockweekFilter"
          [groups]="groups"
          [availableFilters]="availableFilters"
          [showStockFilter]="selectedTab !== 'preorder'"
          [showMustStockListFilter]="selectedTab === 'preorder'"
          [sidebarTop]="sidebarTop"
          (groupsUpdated)="groupsUpdated($event)"
          (stockweeksUpdated)="stockweeksUpdated($event)"
          (filtersUpdated)="filtersUpdated($event)"
          (filterWithKeyword)="filterWithKeyword($event)"
          [numResults]="collectionSize"
        ></app-side-bar>
      </div>
    }

    @if (selectedTab === 'favorites') {
      <div
        class="px-0 col-md-3 col-lg-2 col-xl-2 col-sm-4 pe-md-0 ps-md-2"
        >
        <h1>
          <app-header-icon iconName="favorite"></app-header-icon
            >{{ "FAVORITES" | translate }}
          </h1>
          <ul class="mt-3 list-group list-group-flush">
            <li class="ps-sm-0 list-group-item">
              <a
                class="text-primary clickable"
                [ngClass]="{ 'fw-bold': favoritesType === 'main' }"
                (click)="favoritesType = 'main'; count = null; setUrl({},true); getResults(true)"
                >{{ "FAVORITES" | translate }}
                @if (count && favoritesType === 'main') {
                  ({{ count }})
                  }</a
                  >
                </li>
                <li class="ps-sm-0 list-group-item">
                  <a
                    class="text-primary clickable"
                    [ngClass]="{ 'fw-bold': favoritesType === 'stocklist' }"
            (click)="
              favoritesType = 'stocklist'; count = null; setUrl({},true); getResults(true)
            "
                    >{{ "SN_STOCK_LIST" | translate }}
                    @if (count && favoritesType === 'stocklist') {
                      ({{ collectionSize }})
                      }</a
                      >
                    </li>
                  </ul>
                </div>
              }

              <div
                class="p-0 m-0 col-xs-12 row search-container"
      [ngClass]="
        selectedTab === 'imagebank' && imageBankTab === 'atmospheric'
          ? 'col-md-12'
          : 'col-md-9 col-sm-8 col-lg-9 col-xl-10'
      "
                >
                <!-- Search results -->
                <div class="px-0 ms-0 col-md-12 mx-xs-0 px-md-2 ms-sm-2">
                  <!-- View options -->
                  <nav
                    class="p-2 mb-2  me-0 mt-sm-2 row mb-md-1 viewOptions"
                    [ngClass]="selectedTab === 'imagebank' && imageBankTab === 'atmospheric' ? 'col-md-10 ms-auto' : 'col-md-12 ms-0'"
                    aria-label="viewOptions"
                    [hidden]="!showViewOptions"
                    >
                    <div class="px-0 col-md-6 col-lg-7 col-12" [hidden]="!showSearchTabs">
                      <app-search-tabs
                        #searchTabs
                        class="px-0 col-md-12"
                        (tabSelected)="setTab($event)"
                        [activeTab]="selectedTab"

                        >
                      </app-search-tabs>
                      @if (!showSearchTabs) {
                        <h3 class="mt-1">
                        </h3>
                      }
                    </div>
                    @if (sideBar) {
                      <div
                        class="ps-2 pe-0 mt-1 d-flex align-items-center listOptions" [ngClass]="{ 'justify-content-md-end': showSearchTabs, 'col-md-6 col-lg-5': !applicationService.isPartnerPortal(), 'col-12': applicationService.isPartnerPortal() }"
                        >
                        @if (
                          selectedTab === 'search' ||
                          selectedTab === 'preorder' ||
                          selectedTab === 'replenishment'
                          ) {
                          <button
                            id="showFilters"
                            class="fab btn d-block d-sm-none p-1 w-auto"
                            style="max-width: 52px"
                            [ngClass]="this.sideBar.sideBarActive ? 'btn-danger' : 'btn-dark'"
              (click)="
                this.sideBar.sideBarActive = !this.sideBar.sideBarActive;
                scrollToTop(0)
              "
                            >
                            <i class="material-icons"> filter_alt </i>
                            @if (this.sideBar.sideBarActive) {
                              <i
                                class="material-icons position-absolute close-filters text-black"
                                >
                                cancel
                              </i>
                            }
                          </button>
                        }
                        @if (
                          selectedTab !== 'preorder' &&
                          selectedTab !== 'replenishment' &&
                          selectedTab !== 'imagebank' &&
                          selectedTab !== 'favorites' &&
                          showSearchTabs
                          ) {
                          <button
              [ngClass]="
                viewType === 'treeview' ? 'bg-white selected border' : 'bg-transparent'
              "
                            class="d-flex align-items-center px-2 py-1 btn btn-default view-button-left"
                            (click)="setViewType('treeview')"
                            >
                            <i class="material-icons"> view_list </i>
                          </button>
                        }
                        @if (
                          selectedTab !== 'preorder' &&
                          selectedTab !== 'replenishment' &&
                          selectedTab !== 'imagebank' &&
                          selectedTab !== 'favorites' &&
                          showSearchTabs
                          ) {
                          <button
              [ngClass]="
                viewType === 'card' ? 'bg-white selected border' : 'bg-transparent'
              "
                            class="d-flex align-items-center px-2 py-1 btn btn-default"
                            (click)="setViewType('card')"
                            >
                            <i class="material-icons"> grid_on </i>
                          </button>
                        }
                        @if (
                          showroomMode &&
                          selectedTab !== 'preorder' &&
                          selectedTab !== 'replenishment' &&
                          selectedTab !== 'imagebank' &&
                          selectedTab !== 'favorites' &&
                          showSearchTabs
                          ) {
                          <button
              [ngClass]="
                viewType === 'images' ? 'bg-white selected border' : 'bg-transparent'
              "
                            class="d-flex align-items-center px-2 py-1 btn btn-default"
                            (click)="setViewType('images')"
                            >
                            <i class="material-icons"> image </i>
                          </button>
                        }
                        <button
                        hidden
              *ngIf="
                selectedTab !== 'preorder' &&
                selectedTab !== 'replenishment' &&
                selectedTab !== 'imagebank' &&
                selectedTab !== 'favorites' &&
                showSearchTabs
              "
              [ngClass]="
                viewType === 'table' ? 'bg-white selected border' : 'bg-transparent'
              "
                        class="d-flex align-items-center px-2 py-1 me-2 btn btn-default view-button-right"
                        (click)="setViewType('table')"
                        >
                        <i class="material-icons"> table_chart </i>
                      </button>
                      @if (
                        selectedTab !== 'preorder' &&
                        selectedTab !== 'replenishment' &&
                        selectedTab !== 'imagebank' &&
                        selectedTab !== 'favorites' &&
                        showSearchTabs
                        ) {
                        <button
              [ngClass]="
                isFullWidth ? 'bg-white selected border' : 'bg-transparent'
              "
                          class="d-flex align-items-center px-2 py-1 me-2 btn btn-default view-button-right"
                          (click)="toggleFullWidth()"
                          [title]="isFullWidth ? ('EXIT_FULL_WIDTH' | translate) : ('FULL_WIDTH_VIEW' | translate)"
                          >
                          <i class="material-icons"> {{ isFullWidth ? 'fullscreen_exit' : 'fullscreen' }} </i>
                        </button>
                      }
                      @if (
                        selectedTab !== 'preorder' &&
                        selectedTab !== 'replenishment' &&
                        showSearchTabs
                        ) {
                        <button
              [ngClass]="
                viewType === 'swiper' ? 'bg-white selected border' : 'bg-transparent'
              "
                          class="px-2 py-1 pb-0 me-2 btn btn-default view-button-right d-block d-sm-none"
                          (click)="setViewType('swiper')"
                          >
                          <i class="material-icons"> favorite </i>
                        </button>
                      }
                      @if (selectedTab === 'replenishment') {
                        <button
                          class="me-2 btn btn-dark view-button-right btn-sm"
                          (click)="showReplenishmentSelection()"
                          >
                          {{ "REPLENISHMENT_SELECTION" | translate }}
                          <i class="material-icons" style="font-size: 12px"> check </i>
                        </button>
                      }
                      @if (selectedTab === 'replenishment') {
                        <button
                          class="me-2 btn btn-dark view-button-right btn-sm"
              [routerLink]="
                '/' + companyGroupCode + '/companyPage/' + replenishmentHelpId
              "
                          >
                          {{ "REPLENISHMENT_EXPLANATION" | translate }}
                          <i class="material-icons" style="font-size: 12px"> help </i>
                        </button>
                      }
                      @if (showSearchTabs || applicationService.isPartnerPortal()) {
                        <div class="d-flex align-items-center" [class.w-100]="applicationService.isPartnerPortal()">
                          @if (applicationService.isPartnerPortal()) {
                            <label class="pe-2">{{"SORTING"|translate}}</label>
                          }
                          @if (selectedTab === 'search' || selectedTab === 'preorder'  || selectedTab === 'replenishment' || selectedTab === 'favorites') {
                            <select
                              [ngModel]="sorting"
                              style="max-width: 150px"
                              name="sorting"
                              class="me-md-1 form-control sorting"
                              (change)="sortingChange($event.target.value)"
                              >
                              <option value="1" selected="">
                                {{ "RELEVANCE" | translate }}
                              </option>
                              @if (selectedTab !== 'favorites') {
                                <option value="2">{{ "NAME" | translate }} a-z</option>
                                <option value="3">{{ "NAME" | translate }} z-a</option>
                                <option value="4">{{ "PRICE" | translate }} 0-9</option>
                                <option value="5">{{ "PRICE" | translate }} 9-0</option>
                                <option value="6">
                                  {{ "ARTICLE_NO" | translate }} {{ "ASCENDING" | translate }}
                                </option>
                                <option value="7">
                                  {{ "ARTICLE_NO" | translate }} {{ "DESCENDING" | translate }}
                                </option>
                                <option value="8">
                                  {{ "SORT_BASKET_POPULARITY" | translate }}
                                </option>
                              }
                              @if (selectedTab === 'favorites') {
                                <option value="3">{{ "PRICE" | translate }} 0-9</option>
                                <option value="4">{{ "PRICE" | translate }} 9-0</option>
                                <option value="8">
                                  {{ "ADDED" | translate }} ({{ "ASCENDING" | translate }})
                                </option>
                                <option value="7">
                                  {{ "ADDED" | translate }} ({{ "DESCENDING" | translate }})
                                </option>
                              }
                            </select>
                          }
                          @if (applicationService.isPartnerPortal()) {
                            <label class="px-2 d-none d-sm-block">{{"NUM_RESULTS"|translate}}</label>
                          }
                          @if (selectedTab === 'search') {
                            <select
                              [ngModel]="pageSize"
                              style="max-width: 80px"
                              name="pageSize"
                              class="me-1 form-control d-none d-sm-block"
                              (change)="pageSizeChange($event.target.value)"
                              >
                              <option value="24">24</option>
                              <option value="36">36</option>
                              <option value="72">72</option>
                            </select>
                          }
                        </div>
                      }
                    </div>
                  }
                </nav>
                @if (loaded && selectedTab !== 'favorites') {
                  <app-promo-widget
                    class="d-none d-sm-block"
                    [observer]="dataLoadedEmitted$"
                  ></app-promo-widget>
                }
                <app-brand-promo-widget [filters]="filters"></app-brand-promo-widget>
                @if (
                  loaded &&
                  selectedTab === 'favorites' &&
                  favoritesType === 'main' &&
                  !articles?.length
                  ) {
                  <app-favorites-cms-content
                  ></app-favorites-cms-content>
                }
                @if (
                  loaded &&
                  selectedTab === 'favorites' &&
                  favoritesType === 'stocklist' &&
                  !articles?.length
                  ) {
                  <p
                    class="p-3"
                    >
                    <b> {{ "NO_RESULTS" | translate }}</b>
                  </p>
                }
                <div
          [ngClass]="[
            (articles && articles.length && loaded) ||
            (suggestTerms && suggestTerms.showTerms) ||
            selectedTab === 'preorder'
              ? 'hasArticles'
              : '',
            loaded ? 'loaded' : '',
            'view_' + viewType
          ]"
                  >
                  @if (selectedTab !== 'imagebank' && selectedTab !== 'preorder') {
                    @if (selectedTab === 'replenishment') {
                      <app-replenishment-availability-checker
                        class="w-100"
                        (isAvailable)="replenishmentAvailable = $event"
                      ></app-replenishment-availability-checker>
                    }
                    @if (
                      (articles.length &&
                      (viewType === 'card' || viewType === 'images') && selectedTab !== 'replenishment') ||
                      (selectedTab === 'replenishment' && replenishmentAvailable) ||
                      selectedTab === 'favorites'
                      ) {
                      <div
                        class="px-1 pt-sm-5 articleContainer row pt-lg-1 px-sm-0"
                        [@pageAnimations]
                        [@.disabled]="animationsDisabled"
                        >
                        @for (
                          article of articles; track articleId(i,
                          article); let i = $index) {
                          <app-article-card
                            [article]="article"
                            class="card d-flex col-xl-4 col-xs-12 col-sm-6 col-md-6 align-items-stretch"
                  [ngClass]="
                    selectedTab === 'replenishment' ? 'col-lg-6' : 'col-lg-4'
                  "
                            [useLazyLoad]="i > 9"
                            (showArticleDetails)="showArticleDetails($event, i)"
                            (articleSelected)="addToSelection($event)"
                            [leaseRequest]="leaseRequest"
                            [autoShowDetails]="count === 1 || articles.length === 1"
                            [hideOverlay]="selectedTab === 'replenishment'"
                            [hideMatrix]="selectedTab === 'replenishment'"
                            [compact]="viewType === 'images'"
                            >
                            @if (selectedTab === 'replenishment') {
                              <div xl>
                                <app-replenishment-inputs
                                  class="mb-5 d-block"
                                  [article]="article"
                                  [selectionByModel]="replenishmentService.replenishmentSettings?.replenish_by_model"
                                  (inputChanged)="replenishmentNotSaved = true"
                                ></app-replenishment-inputs>
                                @if (article.base_collection) {
                                  <app-focus-model
                                    class="replenishment-focus"
                                    [size]="'default'"
                                  ></app-focus-model>
                                }
                              </div>
                            }
                          </app-article-card>
                        }
                      </div>
                    }
                    <!-- Treeview -->
                    @if (
                      viewType !== 'card' &&
                      viewType !== 'images' &&
                      viewType !== 'swiper' &&
                      viewType !== 'table' &&
                      articles.length &&
                      selectedTab === 'search'
                      ) {
                      <app-tree-view
                        #treeview
                        [articles]="articles"
                        [leaseRequest]="leaseRequest"
                        class="px-3 py-0 w-100 h-100 py-sm-3 pe-lg-4"
                        [observer]="dataLoadedEmitted$"
                        (showArticleDetails)="showArticleDetails($event, treeview.index)"
                        (articleSelected)="addToSelection($event)"
                        (articleCheckedChange)="addToSelection($event)"
                        >
                      </app-tree-view>
                    }
                    <!-- Table View -->
                    @if (
                      viewType === 'table' &&
                      articles.length &&
                      selectedTab === 'search'
                      ) {
                      <app-article-table-view
                        [articles]="articles"
                        [companyGroupCode]="companyGroupCode"
                        class="w-100"
                        (articleClick)="showArticleDetails($event, 0, true, true)"
                        >
                      </app-article-table-view>
                    }
                    @if (
                      viewType === 'swiper' &&
                      articles.length &&
                      selectedTab === 'search'
                      ) {
                      <app-fav-swiper
                        [articles]="articles"
                        (loadMoreArticles)="nextPage()"
                        (closeModal)="setViewType('card')"
                      ></app-fav-swiper>
                    }
                    @if (searchVisible && articles && articles.length) {
                      <div class="d-flex justify-content-around px-2 gap-2">
                        <button
                          class="btn btn-dark btn-block w-100 prevButton d-block d-sm-none"
                          (click)="prevPage()"
                          [disabled]="page === 1"
                          >
                          {{ "PREVIOUS" | translate }}
                        </button>
                        <button
                          class="btn btn-dark btn-block w-100 nextButton d-block d-sm-none next"
                          (click)="nextPage()"
                          [disabled]="collectionSize < pageSize * (page + 1)"
                          >
                          {{ "NEXT" | translate }}
                        </button>
                      </div>
                    }
                  }

                  <!-- Preorder -->
                  @if (selectedTab === 'preorder') {
                    <app-preorder-container
                      id="preorderContainer"
                      [settings]="searchTabs.preorderSettings"
                      class="d-block w-100"
                      [ngClass]="checkedUnsaved ? 'danger-preorder' : ''"
                      [articles]="articles"
                      [type]="preorderType"
                      (preorderTypeChanged)="preorderTypeChanged($event)"
                      >
                      @if (searchVisible && articles && articles.length) {
                        <div class="mx-0 mt-2 row">
                          <div class="ps-0 pe-1 col-6">
                            <button
                              class="btn btn-dark btn-block w-100 prevButton d-block d-sm-none"
                              (click)="prevPage()"
                              [disabled]="page === 1"
                              >
                              {{ "PREVIOUS" | translate }}
                            </button>
                          </div>
                          <div class="ps-0 pe-1 col-6">
                            <button
                              class="btn btn-dark btn-block w-100 nextButton d-block d-sm-none"
                              (click)="nextPage()"
                              [disabled]="collectionSize < pageSize * (page + 1)"
                              >
                              {{ "NEXT" | translate }}
                            </button>
                          </div>
                        </div>
                      }
                    </app-preorder-container>
                  }

                  <!-- Image bank -->
                  @if (selectedTab === 'imagebank' && loaded) {
                    <app-image-bank-article-container
                      class="d-block w-100 px-0"
                      [@pageAnimations]
                      (tabSelected)="imageBankTab = $event"
                      [articles]="articles"
                      >
                    </app-image-bank-article-container>
                  }

                  <!-- No results -->
                  <div class="w-100 d-flex align-items-center flex-column">
                    @if (loaded && !articles.length) {
                      <app-no-results></app-no-results>
                    }

                    @if (
                      loaded &&
                      !articles.length &&
                      ((filterSearchText === searchText &&
                      filterSearchText && filterSearchKeepFilters) || groupFiltered)
                      ) {
                      <div
                        class="w-100 d-flex align-items-center flex-column"
                        >
                        <p>{{ "WITHIN_CURRENT_SELECTION" | translate }}</p>
                        <button
                          class="btn btn-primary text-center mt-2"
                          (click)="resetFilters(sideBar)"
                          >
                          {{ "SEARCH_ALL_ARTICLES" | translate }}
                        </button>
                      </div>
                    }

                    <!-- Suggest terms -->
                    <app-suggest-terms
              [hidden]="
                selectedTab === 'preorder' ||
                selectedTab === 'replenishment' ||
                !loaded
              "
                      class="m-3 w-100"
                      style="max-width: 1000px"
                      #suggestions
                      [searchTerm]="searchText"
              (getResult)="
                searchText = $event;
                getResults(true, 0);
                suggestions.showTerms = false
              "
                      >
                    </app-suggest-terms>
                  </div>
                  <div class="w-100 d-flex justify-content-center flex-column align-items-center px-2">
                    @if (loaded && !articles.length && showSearchTabs && showWidgets) {
                      <app-promotions-carousel
                          [@inOutAnimation]
                          [hidden]="!showPromotions"
                          (widgetsLoaded)="showPromotions = true"
                          class="my-5 companyBg p-4 rounded-5 w-100"
                          style="max-width: 100%;"
                          [autoload]="true"
                          ><h2 class="text-white ms-2">
                          {{ "ALSO_INTERESTING" | translate }}
                        </h2>
                      </app-promotions-carousel>
                      <app-recommendations-preview class="w-100 mb-3"></app-recommendations-preview>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fixedButtonsContainer">
        @if (showAddAllButton) {
          <button
            class="me-1 rounded btn btn-success addAll"
            (click)="addAll()"
            >
            {{ "ADD_ALL" | translate }} ({{ selectedForBasketCount }})
          </button>
        }
        @if (showAddAllButton) {
          <button
            class="me-1 rounded btn btn-dark compareAddAll"
            (click)="compareAddAll()"
            >
            {{ "COMPARE_ADD_ALL" | translate }} ({{ selectedForBasketCount }})
          </button>
        }
        @if (showAddAllButton) {
          <button
            class="mt-2 rounded btn btn-danger compareAddAll mt-sm-0"
            (click)="clearAddAll()"
            >
            {{ "EMPTY" | translate }}
          </button>
        }
        @if (selectedTab === 'replenishment' && showSaveReplenishment) {
          <button
            class="mt-2 rounded btn btn-success btn-lg mt-sm-0"
            style="min-width: 100px"
            (click)="saveReplenishment()"
            [ngClass]="{ disabled: replenishmentService.loading }"
            [disabled]="replenishmentService.loading || !replenishmentNotSaved"
            >
            {{ "SAVE" | translate }}
          </button>
        }
      </div>
      <!-- Article details -->
      @if (!searchVisible) {
        <app-article-details
          #articleDetails
          (showArticleDetails)="showArticleDetails($event, null)"
          [leaseRequest]="leaseRequest"
          >
        </app-article-details>
      }

      <!-- Paginator -->
      @if ((imageBankTab !== 'atmospheric' && articles && articles.length) && showViewPaginator) {
        <nav
          id="paginator"
          class="navbar navbar-light border-top"
  [ngClass]="[
    !searchVisible && !articles.length ? 'p-0 border-0' : '',
    state === 'fixed' && !staticPaginator ? 'fixed-bottom' : 'static'
  ]"
          [style.z-index]="searchVisible ? '1028' : '95'"
          >
          <div class="container mx-auto mb-0 row">
            <div
              class="ps-0 row justify-content-md-center"
              [ngClass]="searchVisible ? 'd-none' : 'col-md-3'"
            ></div>
            <div
              class="ps-3 pe-0 text-start col-8 col-md-3 row col-xs-12 col-sm-4 numResults"
              [style.display]="searchVisible ? 'block' : 'none'"
              >
              @if (loaded || count > 1) {
                {{ "PAGE" | translate }}: {{ page }} &#xB7;
                {{ "TOTAL_RESULTS" | translate }}: {{ count
                }}{{ count >= 10000 ? "+" : "" }}
              }
            </div>
            <div
              class="px-0 mb-2 col-md-5 col-xs-12 col-sm-12 col-sm-4 mb-md-0 d-md-flex justify-content-md-center"
              [ngClass]="searchVisible ? 'd-none d-sm-flex' : ''"
              >
              @if (!searchVisible && articles.length) {
                <app-article-options
                  (navigationChange)="navigationChange($event)"
                  [selectedIndex]="selectedIndex"
                  [page]="page"
                  class="d-flex"
                  >
                </app-article-options>
              }
              @if (collectionSize > 0) {
                <ngb-pagination
                  class="searchPagination"
                  [ngClass]="searchVisible ? 'd-none d-sm-block' : 'd-none'"
                  [collectionSize]="collectionSize"
                  [(page)]="page"
                  [boundaryLinks]="false"
                  [pageSize]="pageSize"
                  [maxSize]="8"
                  [rotate]="true"
                  [boundaryLinks]="true"
                  (pageChange)="onPager($event)"
                  [boundaryLinks]="true"
                  [ellipses]="false"
                  >
                </ngb-pagination>
              }
            </div>
            @if (!searchVisible) {
              <div class="col-md-1 row col-xs-6 col-sm-4"></div>
            }
            <div class="px-0 col-md-3 col-xs-6 col-sm-4"></div>
          </div>
        </nav>
      }
